export default function ListScrollFooter({ loadMoreRef, loadingMore, showAllShown }) {
    return (
        <>
            <div ref={loadMoreRef} className="h-1" aria-hidden />

            {loadingMore ? (
                <div className="mt-4 flex justify-center py-3">
                    <span
                        className="spinner-border spinner-border-sm text-slate-700"
                        role="status"
                        aria-hidden
                    />
                </div>
            ) : null}

            {showAllShown ? (
                <p className="mt-4 text-center text-xs text-slate-400">All shown</p>
            ) : null}
        </>
    );
}
